import axios from "axios";

// change to work with ENV
const LAMBDA_ENDPOINT = `https://${process.env.EDO_ENV === "production" ? "" : "staging-"}player.edo.com/api/creative_id/`;

export const getCreativeData = async (creative_id) => {
  const response = await axios.get(`${LAMBDA_ENDPOINT}?creative_id=${creative_id}`);

  return response?.data;
}